var _style, _g, _g2, _defs, _g3, _g4, _g5, _path, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsletter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 284.9 173.4",
    style: {
      enableBackground: "new 0 0 284.9 173.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;}\n\t.st1{fill:#DDDEE6;}\n\t.st2{fill:#272727;}\n\t.st3{fill:#191414;}\n\t.st4{fill:#3D3838;}\n\t.st5{opacity:0.1;fill:#CFD5D5;enable-background:new    ;}\n\t.st6{opacity:0.2;fill:#CFD5D5;enable-background:new    ;}\n\t.st7{fill:#161515;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{fill:#001531;}\n\t.st10{fill:#0537A0;}\n\t.st11{fill:#CCCCCC;}\n\t.st12{fill:#475563;}\n\t.st13{fill:#ABABAB;}\n\t.st14{fill:#0E3689;}\n\t.st15{fill:#132F6A;}\n\t.st16{fill:#185AE6;}\n\t.st17{fill:#B5B5B5;}\n\t.st18{fill:#D8D8D8;}\n\t.st19{fill:#EFEFEF;}\n\t.st20{fill:#5D7ACC;}\n\t.st21{fill:none;stroke:#E9ECF2;}\n\t.st22{fill:#A67204;}\n\t.st23{fill:#895E03;}\n\t.st24{fill:#F1A606;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-110.658 -142.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1-2",
    transform: "translate(120.823 142.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15892",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15835"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_0",
    transform: "translate(1.835 7.376)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -7.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81580-2",
    className: "st1",
    d: "M277.6,102.5L120.7,12c-8.4-4.9-22-4.9-30.4,0L9.2,58.9c-8.4,4.9-8.5,12.7-0.1,17.6 L166,167c8.4,4.9,22,4.9,30.4,0l81.1-46.9C285.9,115.3,286,107.4,277.6,102.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15816",
    transform: "translate(0 0.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81623",
    className: "st2",
    d: "M273,106.7L-9.2,58.2l0,8c0,3.3,2.2,6.6,6.6,9.2l160.7,92.7c8.8,5.1,23.1,5.1,31.9,0 l76.3-44.1c4.5-2.6,6.7-5.9,6.7-9.3L273,106.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15806",
    transform: "translate(0.894 0.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81624",
    className: "st3",
    d: "M263.2,115.7l-73.6,42.4c-6,3.4-13,4.7-19.8,3.7c-2.6-0.3-5.3-0.9-7.8-1.8L-4.4,63.9 c-3.3-1.9-7.5-6.5-2.4-12.2L71.1,6.1C77,2.5,85.7,0.3,92.6,1.2c3,0.4,6.9,1.1,8.6,2.1l165.7,95.3 C274,102.7,270.4,111.6,263.2,115.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81625",
    className: "st4",
    d: "M266.4,97.5L105.7,4.8c-8.8-5.1-23.1-5.1-31.9,0L-2.5,48.9c-8.8,5.1-8.9,13.4-0.1,18.5 l160.7,92.7c8.8,5.1,23.1,5.1,31.9,0l76.3-44.1C275.2,110.9,275.2,102.6,266.4,97.5z M159.4,157.6L-4,63.3 c-3-1.7-4-5.6-2.3-8.5c0.5-1,1.3-1.7,2.3-2.3l19.7-11.4c0.3-0.2,0.7-0.3,1.1-0.4L31.9,39c0.3,0,0.6-0.1,0.8-0.3L56.5,25 c0.3-0.2,0.6-0.5,0.8-0.8L63,14c0.1-0.2,0.3-0.4,0.6-0.6l12.1-7c8.9-5.1,19.8-5.1,28.7,0l162.2,93.6c3.4,2,4.6,6.4,2.6,9.8 c-0.6,1.1-1.5,2-2.6,2.6l-78.1,45.1C179.5,162.8,168.4,162.8,159.4,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81626",
    className: "st3",
    d: "M49.4,22.2l-15.9,9.2c-0.9,0.5-1,1.3-0.2,1.7c0.9,0.4,2,0.4,3-0.1l15.9-9.2 c0.9-0.5,1-1.3,0.2-1.7C51.4,21.6,50.3,21.7,49.4,22.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15809",
    transform: "translate(18.239 77.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81627",
    className: "st4",
    d: "M10.6,12c-0.2-0.5-0.4-0.9-0.7-1.3c-0.3-0.4-0.7-0.8-1.1-1L-5.7,1.3 C-6.1,1-6.7,0.9-7.1,1.1L-8.6,2c0.5-0.2,1-0.2,1.4,0.1l14.6,8.4c0.4,0.3,0.8,0.6,1.1,1C8.8,12,9,12.4,9.2,12.8 c0.1,0.4,0.2,0.7,0.2,1.1v0.6c0.1,0.5-0.2,1-0.6,1.3l1.4-0.8c0.4-0.3,0.6-0.8,0.6-1.3v-0.6C10.8,12.8,10.8,12.4,10.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81628",
    className: "st4",
    d: "M7.4,10.5L-7.2,2.1c-1.1-0.6-2-0.1-2,1.2v0.6c0.1,1.4,0.8,2.7,2,3.4l14.6,8.4 c1.1,0.6,2,0.1,2-1.2V14C9.3,12.6,8.6,11.3,7.4,10.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15808",
    transform: "translate(22.262 12.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81629",
    className: "st4",
    d: "M10.6,12c-0.2-0.5-0.4-0.9-0.7-1.3c-0.3-0.4-0.7-0.8-1.1-1L-5.7,1.3 C-6.1,1-6.7,0.9-7.1,1.1L-8.6,2c0.5-0.2,1-0.2,1.4,0.1l14.6,8.4c0.4,0.3,0.8,0.6,1.1,1C8.8,12,9,12.4,9.2,12.8 c0.1,0.4,0.2,0.7,0.2,1.1v0.6c0.1,0.5-0.2,1-0.6,1.3l1.4-0.8c0.4-0.3,0.6-0.8,0.6-1.3v-0.6C10.8,12.7,10.8,12.4,10.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81630",
    className: "st4",
    d: "M7.4,10.5L-7.2,2.1c-1.1-0.6-2-0.1-2,1.2v0.6c0.1,1.4,0.8,2.7,2,3.4l14.6,8.4 c1.1,0.6,2,0.1,2-1.2V14C9.3,12.6,8.6,11.3,7.4,10.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15812",
    transform: "translate(34.957 33.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81631",
    className: "st3",
    d: "M-4.5,3.7c-1.2,0.6-2.7,0.6-3.9,0C-9,3.5-9.3,2.8-9.1,2.2C-9,1.9-8.7,1.6-8.4,1.5 c1.2-0.6,2.7-0.6,3.9,0C-3.9,1.7-3.5,2.4-3.7,3C-3.9,3.3-4.1,3.6-4.5,3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15811",
    transform: "translate(0.739 0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81632",
    className: "st5",
    d: "M-8.5,3c0.9,0.4,2,0.4,2.9-0.1C-5.2,2.8-5,2.3-5.2,1.8c-0.1-0.3-0.3-0.5-0.6-0.5 c-0.9-0.4-2-0.4-2.9,0.1c-0.5,0.2-0.7,0.7-0.5,1.1C-9,2.8-8.8,3-8.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81633",
    className: "st5",
    d: "M-7.9,2.6c0.5,0.2,1.1,0.2,1.6,0C-6.1,2.5-6,2.2-6.1,1.9c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.5-0.2-1.1-0.2-1.6,0c-0.2,0.1-0.4,0.4-0.3,0.6C-8.2,2.4-8.1,2.6-7.9,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81634",
    className: "st6",
    d: "M-7.5,2.3c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.1-0.1,0.1-0.2C-6.8,2-6.8,2-6.9,1.9 c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0-0.1,0.1-0.1,0.2C-7.6,2.2-7.5,2.3-7.5,2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15815",
    transform: "translate(229.847 135.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81635",
    className: "st7",
    d: "M3.4,5.7l-10.4,6c-1.2,0.7-2.2,0.3-2.2-0.9C-9,9.3-8.2,8-7,7.3l10.4-6 c1.2-0.7,2.2-0.3,2.2,0.9C5.4,3.7,4.6,5,3.4,5.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15821",
    transform: "translate(2.046 2.305)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M157.4,156L-6,61.7c-3-1.7-4-5.6-2.3-8.5c0.5-1,1.3-1.7,2.3-2.3l19.7-11.4c0.3-0.2,0.7-0.3,1.1-0.4 l15.1-1.8c0.3,0,0.6-0.1,0.8-0.3l23.8-13.7c0.3-0.2,0.6-0.5,0.8-0.8L61,12.4c0.1-0.2,0.3-0.4,0.6-0.6l12.1-7 c8.9-5.1,19.8-5.1,28.7,0l162.2,93.6c3.4,2,4.6,6.4,2.6,9.8c-0.6,1.1-1.5,2-2.6,2.6L186.5,156 C177.5,161.2,166.4,161.2,157.4,156z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15820",
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15819",
    transform: "translate(-14.754 -2.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81638",
    className: "st9",
    d: "M292.9,126.3l-92.1,53.1c-1.5,0.8-3.3,0.8-4.7,0L0.3,66.5c-2.3-1.3-3-4.2-1.7-6.5 c0.4-0.7,1-1.3,1.7-1.7L96.6,2.7c3.9-2.3,8.8-2.3,12.7,0l183.5,106c4.9,2.8,6.5,9.1,3.7,13.9 C295.7,124.2,294.4,125.4,292.9,126.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15818",
    transform: "translate(0 3.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81639",
    className: "st9",
    d: "M294.9,105.3l-100.6,59.5l-46.1-14.5l110.6-64.6L294.9,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81640",
    className: "st10",
    d: "M144.9,73l-29.4,17l-44-25.4l29.4-17L144.9,73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81641",
    className: "st10",
    d: "M195.6,96.3l-7.1,4.1l-20.5-11.8l7.1-4.1L195.6,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81642",
    className: "st10",
    d: "M229.6,67.5l-7.1,4.1L202,59.8l7.1-4.1L229.6,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81643",
    className: "st10",
    d: "M90.5,48.4l-6.4,3.7l-6.5-3.7l6.4-3.7L90.5,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81644",
    className: "st10",
    d: "M82.5,40l-15.9,9.2l-12.1-7L70.4,33L82.5,40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81645",
    className: "st10",
    d: "M113.3,19.8l-14.8,8.6L65.9,9.6L80.7,1L113.3,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81646",
    className: "st10",
    d: "M98.8,43.6l-6.4,3.7l-6.5-3.7l6.4-3.7L98.8,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81647",
    className: "st10",
    d: "M126.4,103.1l7.1,4.1l16.4-9.4l-7.1-4.1L126.4,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81648",
    className: "st9",
    d: "M131.8,80.3l-11.4-6.6l8.2-4.7l-22.1-12.8l-8.2,4.7l-11.1-6.4l-2.7,1.6l11.1,6.4 l-9.3,5.3l22.1,12.8l9.3-5.3l11.4,6.6L131.8,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81649",
    className: "st11",
    d: "M73.8,42.7l-10.5-6.1l-2.7,1.6l11.2,6.5L73.8,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81650",
    className: "st12",
    d: "M201.5,113.2l-60.7-35l2.9-1.7l60.7,35L201.5,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81651",
    className: "st12",
    d: "M189.1,104.3l51.1-29.5l-1.8-1.1l-51.1,29.5L189.1,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81652",
    className: "st12",
    d: "M166.4,91.3l-1.7-1l-21.5,12.4l35.9,20.7l1.7-1l-34.1-19.7L166.4,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81653",
    className: "st12",
    d: "M247.6,135.3L205,110.7l5.4-3.1l42.6,24.6L247.6,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81654",
    className: "st12",
    d: "M237,141.4l-42.6-24.6l5.4-3.1l42.6,24.6L237,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81655",
    className: "st12",
    d: "M136,12.3L24,77l-5.1-3l112-64.7L136,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81656",
    className: "st12",
    d: "M116.4,39.1l-52,30l-2.9-1.7l52-30L116.4,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81657",
    className: "st12",
    d: "M45.8,34.6l-52,30l-2.9-1.7l52-30L45.8,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81658",
    className: "st12",
    d: "M195.9,47L84.1,111.5l-4.6-2.6l111.8-64.6L195.9,47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81659",
    className: "st12",
    d: "M253.2,80l-119.4,68.9l6,3.4l119.4-68.9L253.2,80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81660",
    className: "st12",
    d: "M114.9,93.1L19.5,38l2.9-1.7l95.4,55.1L114.9,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81661",
    className: "st12",
    d: "M160.7,66.6L66.5,12.2l2.9-1.7l94.3,54.4L160.7,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81662",
    className: "st12",
    d: "M116.6,19.3L85.3,1.2l-2.9,1.7l30.6,17.6C114.1,20,115.4,19.6,116.6,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81663",
    className: "st12",
    d: "M101.4,46.5l-0.9,1l44.2,25.5l0.9-1L101.4,46.5z"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15822",
    transform: "translate(11.214 12.127)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81665",
    className: "st13",
    d: "M115.3,72.8l-9,5.2l14.9,8.6h5.6L115.3,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81666",
    className: "st13",
    d: "M161.7,106.7l-15.6-16.1l-9,5.2l6.3,3.6l-2.8,1.6l11.3,6.5h4l-1.6-1.9l1.8,1 L161.7,106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81667",
    className: "st13",
    d: "M171.4,83l-17.7-10.2l-4.3,2.5l18.3,10.6h6.1L171.4,83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81668",
    className: "st13",
    d: "M106,77.8c-1.6,1.6-3.1,3.2-4.5,4.9l5.9,3.4h5.6L106,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81669",
    className: "st13",
    d: "M142,57c-1.6,1.6-3.1,3.2-4.5,4.9l5.9,3.4h5.6L142,57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81670",
    className: "st13",
    d: "M148.7,53.1c-1.6,1.6-3.1,3.2-4.5,4.9l5.9,3.4h5.6L148.7,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81671",
    className: "st13",
    d: "M169.1,41.5c-1.6,1.6-3.1,3.2-4.5,4.9l5.9,3.4h5.6L169.1,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81672",
    className: "st13",
    d: "M87.6,88.7c-0.2,0.1-0.3,0.2-0.5,0.3c-1.5,1.5-3.1,2.9-4.8,4.1l6.6,3.8h5.6L87.6,88.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81673",
    className: "st13",
    d: "M77.4,94.9l-9,5.2l14.9,8.6H89L77.4,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81674",
    className: "st13",
    d: "M95.6,105.4l-9,5.2l14.9,8.6h5.6L95.6,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81675",
    className: "st13",
    d: "M119.2,93.1l-9,5.2l19.2,11.1h5.6L119.2,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81676",
    className: "st13",
    d: "M50.6,65.1l-9.3,5.3l11.9,6.9h6.2L50.6,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81677",
    className: "st13",
    d: "M124.1,121.9l-9,5.2l3.5,2h5.6L124.1,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81678",
    className: "st13",
    d: "M206.4,73.4l-9,5.2l4.4,2.5h5.6L206.4,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81679",
    className: "st13",
    d: "M152.3,32.9l-9,5.2l5.2,3h5.6L152.3,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81680",
    className: "st13",
    d: "M89.9,1l-7,4l4.1,2.4h4.4L89.9,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81681",
    className: "st13",
    d: "M28.3,34.7l-9,5.2l4.6,2.6h5.6L28.3,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81682",
    className: "st13",
    d: "M39.3,66.5L39,64.4L23.6,56l-0.4-2.6l-9,5.2l4.6,2.6h5.6L24.2,60l0.3,0.6l8.6,5 l-3.4,2l4.6,2.6h5.6L39.3,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81683",
    className: "st13",
    d: "M12.7,50.6l-2.9,1.1l1,0.6h2.5L12.7,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81684",
    className: "st13",
    d: "M-0.2,50.2l-9,5.2l4.6,2.6H1L-0.2,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81685",
    className: "st13",
    d: "M1.6,43l-9,5.2l9.9,5.7h5.6L1.6,43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81686",
    className: "st13",
    d: "M51.1,40.9l-16.2,0l-10.4,6l8.5,4.9h11.9L51.1,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81687",
    className: "st13",
    d: "M83.3,52.1l-8.7,0l-10.4,6L80,67.1h4.3L83.3,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81688",
    className: "st13",
    d: "M84,25.4l-29,0l-8.6,5l5.6,3.2h26.2L84,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81689",
    className: "st13",
    d: "M134.3,116l-9,5.2l3.5,2h5.6L134.3,116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81690",
    className: "st13",
    d: "M137.4,85.6l-9,5.2l4,2.3h5.6L137.4,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81691",
    className: "st13",
    d: "M115.3,111.2h2.6l-10.8-13.4l-7.5,4.3L115.3,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81692",
    className: "st13",
    d: "M11.2,67.1h2.6l-0.8-3.4c-0.5-2.4-0.8-2.2-2.9-1l-3.2,1.9L11.2,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81693",
    className: "st13",
    d: "M53.6,91.6h3.5l2.1-2.7l-5.1-2.1l-4.4,2.5L53.6,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81694",
    className: "st13",
    d: "M46,84.8h4.2l2.1-2.7l-11.2-5.3l-4.4,2.5L46,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81695",
    className: "st13",
    d: "M30.5,77.9h2.6l-0.7-3.4c-0.5-2.4-10.9-8-13-6.8l-3.2,1.9L30.5,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81696",
    className: "st13",
    d: "M178.9,76l4.1,2.4h4.4l-4.1-4.9L178.9,76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81697",
    className: "st13",
    d: "M166,59.5l-5,2.9l5.3,3.1l-1,0.6l2.3,1.3h2l1.4,0.8h4.5L166,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81698",
    className: "st13",
    d: "M99.9,42.3l-6.2,3.6l18.6,10.7l-1.2,0.7L114,59h2.5l0.7,0.4h5.6L99.9,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81699",
    className: "st13",
    d: "M188.2,70.6l4.1,2.4h4.4l-4.1-4.9L188.2,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81700",
    className: "st13",
    d: "M173.9,97.9h4.5l-0.2-7.2l-8.4,4.9L173.9,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81701",
    className: "st13",
    d: "M137.6,77.3h5.6l-2.4-2.8L130.5,64l-8,4.6L137.6,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81702",
    className: "st13",
    d: "M131.7,50.9h5.6l-2.4-2.8l-14.3-12.8l-8,4.6L131.7,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81703",
    className: "st13",
    d: "M89.1,43.2h5.6l-2.4-2.8l-4.3-7l-8,4.6L89.1,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81704",
    className: "st13",
    d: "M136.7,34.3h2.8l-1.2-1.4l-7.6-6.6l-3.9,2.2L136.7,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81705",
    className: "st13",
    d: "M116.5,30h2.8l-1.2-1.4l-3.8-4.4l-3.9,2.2L116.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81706",
    className: "st13",
    d: "M103.7,34.7h5.6l-2.4-2.8L87.8,16.3l-8,4.6L103.7,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81707",
    className: "st13",
    d: "M59.5,19.3L50,11.5l-8,4.6l10.4,6l-2.9,1.7l4.5,2.6h2.8L59.5,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81708",
    className: "st13",
    d: "M123.7,23.2h5.6l-2.4-2.8L107.8,4.8l-8,4.6L123.7,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81709",
    className: "st13",
    d: "M27.4,32.2h2.1l0.3-6.9l-7.2,4.2L27.4,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81710",
    className: "st13",
    d: "M75.5,86.6L63.7,75.7l-6.3,3.6l5.5,3.2l-3.6,2.1l4.8,2.8h5.6l-1-1.5l1.1,0.7 L75.5,86.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15834",
    transform: "translate(16.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube",
    transform: "translate(26.744 57.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left",
    className: "st14",
    d: "M11.3,16.5L-9.2,4.7v5.7l20.5,11.8V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right",
    className: "st15",
    d: "M17.7,18.5l-6.4,3.7v-5.7l6.4-3.7V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top",
    className: "st16",
    d: "M11.3,16.5L-9.2,4.7L-2.7,1l20.5,11.8L11.3,16.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-2",
    transform: "translate(23.139 61.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-2",
    className: "st14",
    d: "M-4.1,6l-5-2.9v5.7l5,2.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-2",
    className: "st15",
    d: "M-0.5,9.6l-3.6,2.1V6l3.6-2.1V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-2",
    className: "st16",
    d: "M-4.1,6l-5-2.9L-5.5,1l5,2.9L-4.1,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-3",
    transform: "translate(12.624 70.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-3",
    className: "st14",
    d: "M-4.1,5.9l-5-2.9v2.6l5,2.9V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-3",
    className: "st15",
    d: "M-0.7,6.5l-3.5,2V5.9l3.5-2V6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-3",
    className: "st16",
    d: "M-4.1,5.9l-5-2.9l3.5-2l5,2.9L-4.1,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-4",
    transform: "translate(38.61 70.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-4",
    className: "st14",
    d: "M-4.1,6l-5-2.9v5.7l5,2.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-4",
    className: "st15",
    d: "M-0.5,9.6l-3.6,2.1V6l3.6-2.1V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-4",
    className: "st16",
    d: "M-4.1,6l-5-2.9L-5.5,1l5,2.9L-4.1,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-5",
    transform: "translate(116.16 33.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-5",
    className: "st17",
    d: "M-2.3,6.9l-6.9-4v2.1l6.9,4V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-5",
    className: "st18",
    d: "M1.1,7.1l-3.4,2V6.9l3.4-2V7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-5",
    className: "st19",
    d: "M-2.3,6.9l-6.9-4l3.4-2l6.9,4L-2.3,6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-6",
    transform: "translate(89.034 40.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-6",
    className: "st14",
    d: "M0.3,9.2l-9.5-5.5v5.7l9.5,5.5V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-6",
    className: "st15",
    d: "M5.1,12.2l-4.8,2.8V9.2l4.8-2.8V12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-6",
    className: "st16",
    d: "M0.3,9.2l-9.5-5.5L-4.4,1l9.5,5.5L0.3,9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-7",
    transform: "translate(51.638 18.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-7",
    className: "st14",
    d: "M4.5,11.7L-9.2,3.8v5.7l13.7,7.9V11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-7",
    className: "st15",
    d: "M9.3,14.6l-4.8,2.8v-5.7l4.8-2.8V14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-7",
    className: "st16",
    d: "M4.5,11.7L-9.2,3.8L-4.4,1L9.3,8.9L4.5,11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15823",
    transform: "translate(89.16 12.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-8",
    transform: "translate(4.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-8",
    className: "st15",
    d: "M-4.4,15.6L16.2,3.8v5.7L-4.4,21.3V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-8",
    className: "st15",
    d: "M-9.2,18.6l4.8,2.8v-5.7l-4.8-2.8V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-8",
    className: "st16",
    d: "M-4.4,15.6L16.2,3.8L11.4,1L-9.2,12.9L-4.4,15.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-9",
    transform: "translate(0 11.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-9",
    className: "st14",
    d: "M14.8,17.6l-24-13.8v5.7l24,13.8V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-9",
    className: "st15",
    d: "M19.6,20.5l-4.8,2.8v-5.7l4.8-2.8V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-9",
    className: "st16",
    d: "M14.8,17.6l-24-13.8L-4.4,1l24,13.8L14.8,17.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-10",
    transform: "translate(24.776 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-10",
    className: "st14",
    d: "M10,16.6L-9.2,5.5v5.7L10,22.3V16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-10",
    className: "st15",
    d: "M14.8,19.5L10,22.3v-5.7l4.8-2.8V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-10",
    className: "st16",
    d: "M10,16.6L-9.2,5.5L-7.4,1l22.2,12.8L10,16.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15824",
    transform: "translate(151.098 47.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-11",
    transform: "translate(4.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-11",
    className: "st15",
    d: "M-4.4,15.8L16.5,3.8v5.7L-4.4,21.5L-4.4,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-11",
    className: "st15",
    d: "M-9.2,18.8l4.8,2.8v-5.7l-4.8-2.8V18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-11",
    className: "st16",
    d: "M-4.4,15.8L16.5,3.8L11.7,1L-9.2,13.1L-4.4,15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-12",
    transform: "translate(0 11.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-12",
    className: "st14",
    d: "M-0.8,8.6l-8.4-4.8v5.7l8.4,4.8V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-12",
    className: "st15",
    d: "M4,11.5l-4.8,2.8V8.6L4,5.8V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-12",
    className: "st16",
    d: "M-0.8,8.6l-8.4-4.8L-4.4,1L4,5.8L-0.8,8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-13",
    transform: "translate(25.135 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-13",
    className: "st14",
    d: "M-5.6,7.6l-3.6-2.1v5.7l3.6,2.1V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-13",
    className: "st15",
    d: "M-0.8,10.5l-4.8,2.8V7.6l4.8-2.8V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-13",
    className: "st16",
    d: "M-5.6,7.6l-3.6-2.1L-7.4,1l6.6,3.8L-5.6,7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15825",
    transform: "translate(131.104 63.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-14",
    transform: "translate(4.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-14",
    className: "st15",
    d: "M-4.4,11.8l13.8-8v5.7l-13.8,8V11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-14",
    className: "st15",
    d: "M-9.2,14.7l4.8,2.8v-5.7L-9.2,9V14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-14",
    className: "st16",
    d: "M-4.4,11.8l13.8-8L4.7,1L-9.2,9L-4.4,11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-15",
    transform: "translate(0 7.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-15",
    className: "st14",
    d: "M6.8,13L-9.2,3.8v5.7l15.9,9.2V13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-15",
    className: "st15",
    d: "M11.6,15.9l-4.8,2.8V13l4.8-2.8V15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-15",
    className: "st16",
    d: "M6.8,13L-9.2,3.8L-4.4,1l15.9,9.2L6.8,13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-16",
    transform: "translate(18.081 1.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-16",
    className: "st14",
    d: "M-5.6,7.6l-3.6-2.1v5.7l3.6,2.1V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-16",
    className: "st15",
    d: "M-0.8,10.5l-4.8,2.8V7.6l4.8-2.8V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-16",
    className: "st16",
    d: "M-5.6,7.6l-3.6-2.1L-7.4,1l6.6,3.8L-5.6,7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-17",
    transform: "translate(177.464 92.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-17",
    className: "st15",
    d: "M-4.4,11.8l13.8-8v5.7l-13.8,8V11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-17",
    className: "st14",
    d: "M-9.2,14.7l4.8,2.8v-5.7L-9.2,9V14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-17",
    className: "st16",
    d: "M-4.4,11.8l13.8-8L4.7,1L-9.2,9L-4.4,11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-18",
    transform: "translate(55.783 29.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-18",
    className: "st15",
    d: "M-4.4,6.5l4.7-2.7v2.9l-4.7,2.7V6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-18",
    className: "st14",
    d: "M-9.2,6.6l4.8,2.8V6.5l-4.8-2.8V6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-18",
    className: "st16",
    d: "M-4.4,6.5l4.7-2.7L-4.4,1l-4.7,2.7L-4.4,6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-19",
    transform: "translate(133.453 116.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-19",
    className: "st15",
    d: "M-4.4,13.1l16.2-9.3v5.7l-16.2,9.3V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-19",
    className: "st14",
    d: "M-9.2,16l4.8,2.8v-5.7l-4.8-2.8V16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-19",
    className: "st16",
    d: "M-4.4,13.1l16.2-9.3L7,1l-16.2,9.3L-4.4,13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-20",
    transform: "translate(123.258 128.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-20",
    className: "st15",
    d: "M-4.4,8.7l8.6-4.9v4l-8.6,4.9V8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-20",
    className: "st14",
    d: "M-9.2,9.9l4.8,2.8v-4l-4.8-2.8V9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-20",
    className: "st16",
    d: "M-4.4,8.7l8.6-4.9L-0.6,1l-8.6,4.9L-4.4,8.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-21",
    transform: "translate(206.394 74.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-21",
    className: "st15",
    d: "M-4.4,13.3l16.5-9.5v5.7L-4.4,19V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-21",
    className: "st14",
    d: "M-9.2,16.2l4.8,2.8v-5.7l-4.8-2.8V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-21",
    className: "st16",
    d: "M-4.4,13.3l16.5-9.5L7.3,1l-16.5,9.5L-4.4,13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-22",
    transform: "translate(160.063 119.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-22",
    className: "st15",
    d: "M-4.4,13.3l16.5-9.5v5.7L-4.4,19V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-22",
    className: "st14",
    d: "M-9.2,16.2l4.8,2.8v-5.7l-4.8-2.8V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-22",
    className: "st16",
    d: "M-4.4,13.3l16.5-9.5L7.3,1l-16.5,9.5L-4.4,13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-23",
    transform: "translate(140.669 131.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-23",
    className: "st15",
    d: "M-4.4,13.3l16.5-9.5v5.7L-4.4,19V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-23",
    className: "st14",
    d: "M-9.2,16.2l4.8,2.8v-5.7l-4.8-2.8V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-23",
    className: "st16",
    d: "M-4.4,13.3l16.5-9.5L7.3,1l-16.5,9.5L-4.4,13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-24",
    transform: "translate(91.075 6.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-24",
    className: "st18",
    d: "M-5.1,8.1l8.3-4.8v4.8l-8.3,4.8V8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-24",
    className: "st17",
    d: "M-9.2,10.6l4,2.3V8.1l-4-2.3V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-24",
    className: "st19",
    d: "M-5.1,8.1l8.3-4.8l-4-2.3l-8.3,4.8L-5.1,8.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-25",
    transform: "translate(195.678 71.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-25",
    className: "st18",
    d: "M-4.4,10.3L7,3.8v3.1l-11.3,6.5V10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-25",
    className: "st17",
    d: "M-9.2,10.6l4.8,2.8v-3.1l-4.8-2.8V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-25",
    className: "st19",
    d: "M-4.4,10.3L7,3.8L2.2,1L-9.2,7.5L-4.4,10.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-26",
    transform: "translate(186.386 79.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-26",
    className: "st15",
    d: "M-4.4,8.2l7.7-4.4v3.1l-7.7,4.4V8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-26",
    className: "st14",
    d: "M-9.2,8.5l4.8,2.8V8.2l-4.8-2.8V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-26",
    className: "st16",
    d: "M-4.4,8.2l7.7-4.4L-1.5,1l-7.7,4.4L-4.4,8.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-27",
    transform: "translate(102.55 48.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-27",
    className: "st15",
    d: "M14.8,17.6l-24-13.8v5.7l24,13.8V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-27",
    className: "st14",
    d: "M19.6,20.5l-4.8,2.8v-5.7l4.8-2.8V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-27",
    className: "st16",
    d: "M14.8,17.6l-24-13.8L-4.4,1l24,13.8L14.8,17.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-28",
    transform: "translate(113.397 61.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-28",
    className: "st14",
    d: "M-1.5,6.8l-7.6-4.4v3.1l7.6,4.4V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-28",
    className: "st15",
    d: "M1,8.5l-2.5,1.4V6.8L1,5.4V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-28",
    className: "st16",
    d: "M-1.5,6.8l-7.6-4.4L-6.7,1L1,5.4L-1.5,6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-29",
    transform: "translate(132.787 35.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-29",
    className: "st17",
    d: "M1.3,9.1l-10.4-6v2.2l10.4,6V9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-29",
    className: "st18",
    d: "M4.9,9.3l-3.6,2.1V9.1L4.9,7V9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-29",
    className: "st19",
    d: "M1.3,9.1l-10.4-6L-5.5,1L4.9,7L1.3,9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-30",
    transform: "translate(28.44 28.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-30",
    className: "st17",
    d: "M-4.3,13.1l-4.9-2.8v2.1l4.9,2.8V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-30",
    className: "st18",
    d: "M11.7,5.9l-16,9.2v-2.1l16-9.2V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-30",
    className: "st19",
    d: "M-4.3,13.1l-4.9-2.8L6.8,1l4.9,2.8L-4.3,13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-31",
    transform: "translate(56.763 94.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-31",
    className: "st17",
    d: "M-5,6l-4.2-2.4v2.9L-5,8.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-31",
    className: "st18",
    d: "M-0.5,6.4L-5,8.9V6l4.5-2.6V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-31",
    className: "st19",
    d: "M-5,6l-4.2-2.4L-4.7,1l4.2,2.4L-5,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-32",
    transform: "translate(169.898 134.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-32",
    className: "st17",
    d: "M-5,6l-4.2-2.4v2.9L-5,8.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-32",
    className: "st18",
    d: "M-0.5,6.4L-5,8.9V6l4.5-2.6V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-32",
    className: "st19",
    d: "M-5,6l-4.2-2.4L-4.7,1l4.2,2.4L-5,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-33",
    transform: "translate(50.226 71.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-33",
    className: "st14",
    d: "M3.9,12.2l-13-7.5v5.7l13,7.5V12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-33",
    className: "st15",
    d: "M10.3,14.2l-6.4,3.7v-5.7l6.4-3.7V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-33",
    className: "st16",
    d: "M3.9,12.2l-13-7.5L-2.7,1l13,7.5L3.9,12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15826",
    transform: "translate(66.246 80.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-34",
    className: "st14",
    d: "M3.9,12.2l-13-7.5v5.7l13,7.5V12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-34",
    className: "st15",
    d: "M10.3,14.2l-6.4,3.7v-5.7l6.4-3.7V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-34",
    className: "st16",
    d: "M3.9,12.2l-13-7.5L-2.7,1l13,7.5L3.9,12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-35",
    transform: "translate(2.248 7.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-35",
    className: "st14",
    d: "M-4.1,6l-5-2.9v5.7l5,2.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-35",
    className: "st15",
    d: "M-0.5,9.6l-3.6,2.1V6l3.6-2.1V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-35",
    className: "st16",
    d: "M-4.1,6l-5-2.9L-5.5,1l5,2.9L-4.1,6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15927",
    transform: "translate(159.986 138.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-36",
    className: "st14",
    d: "M3.9,12.2l-13-7.5v5.7l13,7.5V12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-36",
    className: "st15",
    d: "M10.3,14.2l-6.4,3.7v-5.7l6.4-3.7V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-36",
    className: "st16",
    d: "M3.9,12.2l-13-7.5L-2.7,1l13,7.5L3.9,12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-37",
    transform: "translate(2.248 7.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-37",
    className: "st14",
    d: "M-4.1,6l-5-2.9v5.7l5,2.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-37",
    className: "st15",
    d: "M-0.5,9.6l-3.6,2.1V6l3.6-2.1V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-37",
    className: "st16",
    d: "M-4.1,6l-5-2.9L-5.5,1l5,2.9L-4.1,6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-38",
    transform: "translate(115.09 79.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-38",
    className: "st14",
    d: "M6.4,13.7l-15.5-9v5.7l15.5,9V13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-38",
    className: "st15",
    d: "M12.8,15.7l-6.4,3.7v-5.7l6.4-3.7V15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-38",
    className: "st16",
    d: "M6.4,13.7l-15.5-9L-2.7,1l15.5,9L6.4,13.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-39",
    transform: "translate(118.733 100.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-39",
    className: "st14",
    d: "M10.9,15.2L-9.2,3.6v5.7l20.1,11.6V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-39",
    className: "st15",
    d: "M15.4,18.3l-4.5,2.6v-5.7l4.5-2.6V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-39",
    className: "st16",
    d: "M10.9,15.2L-9.2,3.6L-4.7,1l20.1,11.6L10.9,15.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-40",
    transform: "translate(106.169 106.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-40",
    className: "st17",
    d: "M6.4,13.2l-15.5-9v3.2l15.5,9V13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-40",
    className: "st18",
    d: "M11.9,13.1l-5.6,3.2v-3.2l5.6-3.2V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-40",
    className: "st19",
    d: "M6.4,13.2l-15.5-9L-3.6,1l15.5,9L6.4,13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15827",
    transform: "translate(135.992 95.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-41",
    className: "st14",
    d: "M-3.3,7.2l-5.8-3.4v3l5.8,3.4V7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-41",
    className: "st15",
    d: "M1.5,7.3l-4.9,2.8v-3l4.9-2.8V7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-41",
    className: "st16",
    d: "M-3.3,7.2l-5.8-3.4L-4.3,1l5.8,3.4L-3.3,7.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-42",
    transform: "translate(145.358 96.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-42",
    className: "st14",
    d: "M10.9,16.3L-9.2,4.7v5.7L10.9,22V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-42",
    className: "st15",
    d: "M17.4,18.3L10.9,22v-5.7l6.4-3.7V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-42",
    className: "st16",
    d: "M10.9,16.3L-9.2,4.7L-2.7,1l20.1,11.6L10.9,16.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15828",
    transform: "translate(41.977 38.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-43",
    className: "st14",
    d: "M-2.4,10.6l-6.7-3.9v15.1l6.7,3.9V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-43",
    className: "st15",
    d: "M7.4,20l-9.8,5.7V10.6l9.8-5.7V20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-43",
    className: "st16",
    d: "M-2.4,10.6l-6.7-3.9L0.7,1l6.7,3.9L-2.4,10.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15829",
    transform: "translate(74.142 55.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-44",
    className: "st14",
    d: "M4.9,16.8l-14-8.1v7.4l14,8.1L4.9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-44",
    className: "st15",
    d: "M18.1,16.5L4.9,24.2v-7.4l13.3-7.7V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-44",
    className: "st16",
    d: "M4.9,16.8l-14-8.1L4.1,1l14,8.1L4.9,16.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15830",
    transform: "translate(72.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-45",
    transform: "translate(0 3.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-45",
    className: "st14",
    d: "M-0.1,10.8l-9.1-5.2v31.9l9.1,5.2V10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-45",
    className: "st15",
    d: "M7.7,38.1l-7.8,4.5V10.8l7.8-4.5V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-45",
    className: "st16",
    d: "M-0.1,10.8l-9.1-5.2L-1.3,1l9.1,5.2L-0.1,10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-46",
    transform: "translate(2.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-46",
    className: "st14",
    d: "M-3.1,7.6L-9.2,4v4.7l6.1,3.5V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-46",
    className: "st15",
    d: "M2.2,9.2l-5.3,3V7.6l5.3-3V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-46",
    className: "st16",
    d: "M-3.1,7.6L-9.2,4l5.3-3l6.1,3.5L-3.1,7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15831",
    transform: "translate(2.053 40.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-47",
    transform: "translate(4.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-47",
    className: "st14",
    d: "M0.7,11.6l-9.9-5.7v10.9l9.9,5.7V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-47",
    className: "st15",
    d: "M9.2,17.6l-8.5,4.9V11.6l8.5-4.9V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-47",
    className: "st16",
    d: "M0.7,11.6l-9.9-5.7L-0.7,1l9.9,5.7L0.7,11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-48",
    transform: "translate(0 9.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-48",
    className: "st14",
    d: "M0.7,9.5l-9.9-5.7v6l9.9,5.7V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-48",
    className: "st15",
    d: "M5.6,12.7l-4.9,2.9v-6l4.9-2.9V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-48",
    className: "st16",
    d: "M0.7,9.5l-9.9-5.7L-4.2,1l9.9,5.7L0.7,9.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-49",
    transform: "translate(13.868 17.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-49",
    className: "st14",
    d: "M-8,4.4l-1.1-0.6v2.2l1.1,0.6L-8,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-49",
    className: "st15",
    d: "M-3.3,3.8L-8,6.6V4.4l4.8-2.8V3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-49",
    className: "st16",
    d: "M-8,4.4l-1.1-0.6L-4.4,1l1.1,0.6L-8,4.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-50",
    transform: "translate(147.605 106.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-50",
    className: "st14",
    d: "M2.9,10.1l-12.1-7v3.4l12.1,7V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-50",
    className: "st15",
    d: "M6.5,11.4l-3.6,2.1v-3.4L6.5,8V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-50",
    className: "st16",
    d: "M2.9,10.1l-12.1-7L-5.6,1L6.5,8L2.9,10.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-51",
    transform: "translate(157.56 75.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-51",
    className: "st14",
    d: "M10.9,16.3L-9.2,4.7v5.7L10.9,22V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-51",
    className: "st15",
    d: "M17.3,18.3L10.9,22v-5.7l6.4-3.7V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-51",
    className: "st16",
    d: "M10.9,16.3L-9.2,4.7L-2.7,1l20.1,11.6L10.9,16.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-52",
    transform: "translate(152.018 35.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-52",
    className: "st14",
    d: "M-3.2,8.1l-5.9-3.4v10.1l5.9,3.4V8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-52",
    className: "st15",
    d: "M3.2,14.6l-6.4,3.7V8.1l6.4-3.7V14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-52",
    className: "st16",
    d: "M-3.2,8.1l-5.9-3.4L-2.7,1l5.9,3.4L-3.2,8.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-53",
    transform: "translate(168.379 62.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-53",
    className: "st14",
    d: "M1.8,14.2l-11-6.4v3.8l11,6.4V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-53",
    className: "st15",
    d: "M13.8,11.2L1.8,18.1v-3.8l11.9-6.9L13.8,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-53",
    className: "st16",
    d: "M1.8,14.2l-11-6.4L2.8,1l11,6.4L1.8,14.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-54",
    transform: "translate(171.558 73.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-54",
    className: "st14",
    d: "M-6.8,3.6l-2.4-1.4v2.3l2.4,1.4V3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-54",
    className: "st15",
    d: "M-4.7,4.6l-2.1,1.2V3.6l2.1-1.2V4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-54",
    className: "st16",
    d: "M-6.8,3.6l-2.4-1.4L-7.1,1l2.4,1.4L-6.8,3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15832",
    transform: "translate(121.592 41.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-55",
    transform: "translate(19.58 5.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-55",
    className: "st14",
    d: "M-3.2,6.7l-5.9-3.4v5.7l5.9,3.4V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-55",
    className: "st15",
    d: "M0.6,10.1l-3.9,2.2V6.7l3.9-2.2V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-55",
    className: "st16",
    d: "M-3.2,6.7l-5.9-3.4L-5.3,1l5.9,3.4L-3.2,6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-56",
    className: "st14",
    d: "M10.4,16L-9.2,4.7v5.7l19.5,11.3V16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-56",
    className: "st15",
    d: "M16.8,18l-6.4,3.7V16l6.4-3.7V18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-56",
    className: "st16",
    d: "M10.4,16L-9.2,4.7L-2.7,1l19.5,11.3L10.4,16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-57",
    transform: "translate(44.568 83.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-57",
    className: "st14",
    d: "M0.3,9.2l-9.4-5.5v4.2l9.4,5.5V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-57",
    className: "st15",
    d: "M5,10.6l-4.7,2.7V9.2L5,6.5V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-57",
    className: "st16",
    d: "M0.3,9.2l-9.4-5.5L-4.5,1L5,6.5L0.3,9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-58",
    transform: "translate(21.898 75.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-58",
    className: "st17",
    d: "M5.8,12.4l-15-8.6v2.2l15,8.6V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-58",
    className: "st18",
    d: "M10.5,11.9l-4.7,2.7v-2.2l4.7-2.7V11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-58",
    className: "st19",
    d: "M5.8,12.4l-15-8.6L-4.5,1l15,8.6L5.8,12.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-59",
    transform: "translate(179.209 128.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-59",
    className: "st17",
    d: "M5.8,12.4l-15-8.6v2.2l15,8.6V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-59",
    className: "st18",
    d: "M10.5,11.9l-4.7,2.7v-2.2l4.7-2.7V11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-59",
    className: "st19",
    d: "M5.8,12.4l-15-8.6L-4.5,1l15,8.6L5.8,12.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15833",
    transform: "translate(89.938 83.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-60",
    transform: "translate(4.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-60",
    className: "st15",
    d: "M-4.4,14.7l19-11v5.7l-19,11V14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-60",
    className: "st15",
    d: "M-9.2,17.7l4.8,2.8v-5.7L-9.2,12V17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-60",
    className: "st16",
    d: "M-4.4,14.7l19-11L9.8,1l-19,11L-4.4,14.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-61",
    transform: "translate(0 10.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-61",
    className: "st14",
    d: "M-0.8,8.6l-8.4-4.8v5.7l8.4,4.8V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-61",
    className: "st15",
    d: "M4,11.5l-4.8,2.8V8.6L4,5.8V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-61",
    className: "st16",
    d: "M-0.8,8.6l-8.4-4.8L-4.4,1L4,5.8L-0.8,8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-62",
    transform: "translate(23.223 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-62",
    className: "st14",
    d: "M-5.6,7.6l-3.6-2.1v5.7l3.6,2.1V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-62",
    className: "st15",
    d: "M-0.8,10.5l-4.8,2.8V7.6l4.8-2.8V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-62",
    className: "st16",
    d: "M-5.6,7.6l-3.6-2.1L-7.4,1l6.6,3.8L-5.6,7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-63",
    transform: "translate(81.103 98.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-63",
    className: "st15",
    d: "M-4.4,7.8l6.9-4v5.7l-6.9,4V7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-63",
    className: "st15",
    d: "M-9.2,10.7l4.8,2.8V7.8L-9.2,5V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-63",
    className: "st16",
    d: "M-4.4,7.8l6.9-4L-2.3,1l-6.9,4L-4.4,7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-64",
    transform: "translate(76.878 102.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-64",
    className: "st14",
    d: "M6.8,13L-9.2,3.8v5.7l15.9,9.2V13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-64",
    className: "st15",
    d: "M11.6,15.9l-4.8,2.8V13l4.8-2.8V15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-64",
    className: "st16",
    d: "M6.8,13L-9.2,3.8L-4.4,1l15.9,9.2L6.8,13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-65",
    transform: "translate(95.043 112.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-65",
    className: "st17",
    d: "M6.8,13L-9.2,3.8v5.7l15.9,9.2V13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-65",
    className: "st18",
    d: "M11.6,15.9l-4.8,2.8V13l4.8-2.8V15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-65",
    className: "st19",
    d: "M6.8,13L-9.2,3.8L-4.4,1l15.9,9.2L6.8,13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-66",
    transform: "translate(28.481 42.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-66",
    className: "st15",
    d: "M-4.4,6.5l4.7-2.7v5.7l-4.7,2.7V6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-66",
    className: "st14",
    d: "M-9.2,9.4l4.8,2.8V6.5l-4.8-2.8V9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-66",
    className: "st16",
    d: "M-4.4,6.5l4.7-2.7L-4.4,1l-4.7,2.7L-4.4,6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-67",
    transform: "translate(0 58.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-67",
    className: "st15",
    d: "M-4.4,6.1l4-2.3v5.7l-4,2.3V6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-67",
    className: "st14",
    d: "M-9.2,9l4.8,2.8V6.1l-4.8-2.8V9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-67",
    className: "st16",
    d: "M-4.4,6.1l4-2.3L-5.2,1l-4,2.3L-4.4,6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15925",
    transform: "translate(240.232 88.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-68",
    className: "st14",
    d: "M-2.4,10.6l-6.7-3.9v15.1l6.7,3.9V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-68",
    className: "st15",
    d: "M7.4,20l-9.8,5.7V10.6l9.8-5.7V20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-68",
    className: "st16",
    d: "M-2.4,10.6l-6.7-3.9L0.7,1l6.7,3.9L-2.4,10.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15926",
    transform: "translate(208.928 88.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-69",
    transform: "translate(4.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-69",
    className: "st14",
    d: "M0.7,11.6l-9.9-5.7v10.9l9.9,5.7V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-69",
    className: "st15",
    d: "M9.2,17.6l-8.5,4.9V11.6l8.5-4.9V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-69",
    className: "st16",
    d: "M0.7,11.6l-9.9-5.7L-0.7,1l9.9,5.7L0.7,11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-70",
    transform: "translate(0 9.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-70",
    className: "st14",
    d: "M0.7,9.5l-9.9-5.7v6l9.9,5.7V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-70",
    className: "st15",
    d: "M5.6,12.7l-4.9,2.9v-6l4.9-2.9V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-70",
    className: "st16",
    d: "M0.7,9.5l-9.9-5.7L-4.2,1l9.9,5.7L0.7,9.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-71",
    transform: "translate(13.868 17.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-71",
    className: "st14",
    d: "M-8,4.4l-1.1-0.6v2.2l1.1,0.6L-8,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-71",
    className: "st15",
    d: "M-3.3,3.8L-8,6.6V4.4l4.8-2.8V3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-71",
    className: "st16",
    d: "M-8,4.4l-1.1-0.6L-4.4,1l1.1,0.6L-8,4.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-72",
    transform: "translate(206.875 105.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-72",
    className: "st15",
    d: "M-4.4,6.1l4-2.3v5.7l-4,2.3V6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-72",
    className: "st14",
    d: "M-9.2,9l4.8,2.8V6.1l-4.8-2.8V9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-72",
    className: "st16",
    d: "M-4.4,6.1l4-2.3L-5.2,1l-4,2.3L-4.4,6.1z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82144",
    className: "st20",
    d: "M97.1,62.6c0.5,0.2,0.8,0.7,0.6,1.2c-0.1,0.3-0.3,0.5-0.6,0.6c-1,0.5-2.1,0.5-3.1,0 c-0.5-0.2-0.8-0.7-0.6-1.2c0.1-0.3,0.3-0.5,0.6-0.6C95,62.1,96.2,62.1,97.1,62.6z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15916",
    transform: "translate(95.957 36.684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -106.12, -36.68)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-11",
    className: "st21",
    x1: 100.7,
    y1: 65.1,
    x2: 112.6,
    y2: 58.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909",
    transform: "translate(2.759 18.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224",
    className: "st22",
    d: "M-6.5,7.2l-2.7-1.6l8-4.6l2.7,1.6L-6.5,7.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910",
    transform: "translate(10.74 4.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225",
    className: "st23",
    d: "M-6.4,16.1l-2.7-1.6l0-13.5l2.7,1.6L-6.4,16.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911",
    transform: "translate(2.694 1.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226",
    className: "st24",
    d: "M-9.2,8.8L4.3,1l0.1,19.7l-13.4,7.8L-9.2,8.8z M1.6,19.2l0-13.5l-8,4.6l0,13.5 L1.6,19.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227",
    className: "st22",
    d: "M-6.5,10.3l-2.7-1.6L4.3,1L7,2.6L-6.5,10.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913",
    transform: "translate(0 7.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228",
    className: "st23",
    d: "M-6.4,22.3l-2.7-1.6L-9.2,1l2.7,1.6L-6.4,22.3z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15917",
    transform: "translate(127.203 87.992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -137.37, -87.99)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-12",
    className: "st21",
    x1: 130.1,
    y1: 101.5,
    x2: 135.9,
    y2: 98.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-2",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-2",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-2",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-2",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-2",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-2",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-2",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-2",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-2",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15918",
    transform: "translate(172.457 80.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -182.62, -80.45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-13",
    className: "st21",
    x1: 175.3,
    y1: 93.9,
    x2: 181.2,
    y2: 90.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-3",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-3",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-3",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-3",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-3",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-3",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-3",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-3",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-3",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15919",
    transform: "translate(176.767 43.816)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -186.93, -43.82)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-14",
    className: "st21",
    x1: 179.6,
    y1: 57.3,
    x2: 185.5,
    y2: 54.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-4",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-4",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-4",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-4",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-4",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-4",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-4",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-4",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-4",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15920",
    transform: "translate(29.153 33.041)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -39.32, -33.04)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-15",
    className: "st21",
    x1: 32,
    y1: 46.5,
    x2: 37.9,
    y2: 43.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-5",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-5",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-5",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-5",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-5",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-5",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-5",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-5",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-5",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15921",
    transform: "translate(76.562 1.795)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -86.73, -1.79)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-16",
    className: "st21",
    x1: 79.4,
    y1: 15.3,
    x2: 85.3,
    y2: 12.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-6",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-6",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-6",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-6",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-6",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-6",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-6",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-6",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-6",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15922",
    transform: "translate(58.245 58.901)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -68.41, -58.9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-17",
    className: "st21",
    x1: 61.1,
    y1: 72.4,
    x2: 67,
    y2: 69.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-7",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-7",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-7",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-7",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-7",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-7",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-7",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-7",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-7",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15923",
    transform: "translate(153.063 111.697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -163.23, -111.7)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-18",
    className: "st21",
    x1: 155.9,
    y1: 125.2,
    x2: 161.8,
    y2: 122
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-8",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-8",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-8",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-8",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-8",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-8",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-8",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-8",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-8",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15928",
    transform: "translate(259.733 80.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -269.9, -80.45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-19",
    className: "st21",
    x1: 262.6,
    y1: 93.9,
    x2: 268.5,
    y2: 90.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-9",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-9",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-9",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-9",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-9",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-9",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-9",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-9",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-9",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15924",
    transform: "translate(116.429 8.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -126.59, -8.26)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_111-20",
    className: "st21",
    x1: 119.3,
    y1: 21.8,
    x2: 125.2,
    y2: 18.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15915-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15914-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15909-10",
    transform: "translate(1.366 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82224-10",
    className: "st22",
    d: "M-7.8,4.1l-1.3-0.8l4-2.3l1.3,0.8L-7.8,4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15910-10",
    transform: "translate(5.32 2.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82225-10",
    className: "st23",
    d: "M-7.8,8.5l-1.3-0.8l0-6.7l1.3,0.8L-7.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15911-10",
    transform: "translate(1.334 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82226-10",
    className: "st24",
    d: "M-9.2,4.8L-2.5,1l0,9.8l-6.7,3.8L-9.2,4.8z M-3.8,10l0-6.7l-4,2.3l0,6.7L-3.8,10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15912-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82227-10",
    className: "st22",
    d: "M-7.8,5.6l-1.3-0.8L-2.5,1l1.3,0.8L-7.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15913-10",
    transform: "translate(0 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82228-10",
    className: "st23",
    d: "M-7.8,11.6l-1.3-0.8l0-9.8l1.3,0.8L-7.8,11.6z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.1b4c11dbece3ac0ccccfa49fb0c24872.svg";
export { ForwardRef as ReactComponent };